import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Portfolio() {

    useEffect(() => {
        AOS.init({ duration: 700, easing: 'ease-in-out' });
    }, []);


    const cards = [
        {
            name: "Tienda de ropa",
            url: "https://investrashop.com/Proyectos/#/Fashion",
            image: "https://m.media-amazon.com/images/I/71Ti3B7AJdL._AC_UF894,1000_QL80_.jpg",
            description: "Una tienda moderna con gran variedad de ropa para toda ocasión.",
        },
        // {
        //     name: "Mini super",
        //     url: "https://www.linkedin.com/",
        //     image: "https://files.merca20.com/uploads/2023/10/minisupers12.jpeg",
        //     description: "Un minisúper con los productos básicos para el día a día.",
        // },
        {
            name: "Restaurante",
            url: "https://investrashop.com/Proyectos/#/Angus",
            image: "https://e00-marca.uecdn.es/assets/multimedia/imagenes/2019/02/26/15511968658125.jpg",
            description: "Deliciosos platillos servidos en un ambiente acogedor.",
        },
    ];


    return (
        <div className='bg-white  mt-10 py-16 px-10' data-aos="fade-up" >
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4 nunito-sans-font  text-center" >
                Mira nuestro trabajo
            </h2>
            <div className="flex flex-col md:flex-row flex-wrap gap-6 justify-center p-4">

                {cards.map((card, index) => (
                    <div
                        key={index}
                        className="w-full md:w-[30%] bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group flex flex-col"
                    >
                        <a
                            href={card.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block overflow-hidden"
                        >
                            <img
                                src={card.image}
                                alt={card.name}
                                className="w-full h-48 object-cover transform transition-transform duration-700 group-hover:scale-125"
                            />
                        </a>
                        <div className="p-4 flex flex-col h-40">
                            <div>
                                <h3 className="text-xl text-center font-semibold text-blue-900 mb-2 nunito-sans-font">{card.name}</h3>
                                {/* <p className="text-gray-700 text-sm nunito-sans-font ">{card.description}</p> */}
                            </div>
                            <a
                                href={card.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="nunito-sans-font mt-5 inline-block bg-blue-500  text-white text-center py-2 px-4 rounded-md text-md transition duration-300 hover:bg-blue-800 hover:text-white font-bold" 
                            >
                                Ver sitio
                            </a>
                        </div>
                    </div>
                ))}

            </div>
        </div>

    );
}
